module.exports = __webpack_public_path__ + "static/media/logo-delegacion-cordoba.34f4d30b.png";